module.exports = __webpack_public_path__ + "img/fil_bnd_head_sku_2.prt.7a794a3e.jpg";